import React from 'react';
import { connect } from 'react-redux';

import { State } from '../types';

import ConversationPane from './ConversationPane';

import styles from './PatientFacing.module.css';

export function PatientFacing({ orgName, orgURL }: { orgName: string; orgURL: string }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.messenger}>
        <header>
          <div className={styles.headerContainer}>
            <div className={styles.headerOrgLogo}>{orgURL}</div>
            <div className={styles.headerOrgName}>{orgName}</div>
          </div>
        </header>
        <ConversationPane />
      </div>
    </div>
  );
}

const mapState = (state: State) => ({
  orgName: state.organization.name,
  orgURL: '',
});

export default connect(mapState)(PatientFacing);
